module.exports = __webpack_public_path__ + "static/img/salon_question_zh.3bddb63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/salon_question_zh.png
// module id = 4al7
// module chunks = 34